export default __webpack_public_path__ + "static/media/FarmMountain.0fa68511.jpg";